import React from 'react';
import { useFormContext } from 'react-hook-form';
import CheckboxV2, { CheckboxProps } from '@/components/common/CheckboxV2';
import FormErrorV2 from '@/components/common/form/FormErrorV2';

type CheckboxFieldV2Props = {
	id?: string;
	label?: string;
} & CheckboxProps;

export const CheckboxFieldV2 = ({ id, label, name, required, ...rest }: CheckboxFieldV2Props): React.JSX.Element => {
	const {
		register,
		formState: { errors },
	} = useFormContext();

	return (
		<>
			<CheckboxV2 id={id} label={label} required={required} {...register(name, { required })} {...rest} />

			{errors?.[name] && <FormErrorV2 error={errors[name]} />}
		</>
	);
};

export default CheckboxFieldV2;
